import React from 'react';
import { Link } from 'react-router-dom';
import { FaEnvelope, FaPhoneAlt, FaChevronRight } from 'react-icons/fa';
import { motion } from 'framer-motion';
import { FaLink, FaCogs } from 'react-icons/fa';
import { IoIosArrowUp } from "react-icons/io";
import { FaXTwitter, FaLinkedinIn, FaFacebookF, FaInstagram } from 'react-icons/fa6';

const Footer = () => {
  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-10 px-4 border-t border-amber-400/20">
      <div className="max-w-7xl mx-auto">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16"> 

          {/* Company Info */}
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="space-y-6"
          >
            <h3 className="text-xl font-bold mb-4 border-b border-amber-400/30 pb-2">
              Karikar EduWealth Pvt. Ltd.
            </h3>
            <p className="text-gray-400 mb-4">
              Empowering individuals with financial knowledge and investment solutions for a secure future.
            </p>
            <div className="flex space-x-4">
              <motion.a 
                href="#" 
                className="text-gray-400 hover:text-white transition"
                whileHover={{ y: -3 }}
              >
                <FaFacebookF />
              </motion.a>
              <motion.a 
                href="/" 
                className="text-gray-400 hover:text-white transition"
                whileHover={{ y: -3 }}
              >
                <FaXTwitter />
              </motion.a>
              <motion.a 
                href="/" 
                className="text-gray-400 hover:text-white transition"
                whileHover={{ y: -3 }}
              >
                <FaLinkedinIn />
              </motion.a>
              <motion.a 
                href="/" 
                className="text-gray-400 hover:text-white transition"
                whileHover={{ y: -3 }}
              >
                <FaInstagram />
              </motion.a>
            </div>
          </motion.div>

          {/* Quick Links */}
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="space-y-6"
          >
            <h3 className="text-lg font-bold border-b border-amber-400/30 pb-2 flex items-center">
              <FaLink className="mr-2 text-sm" /> Quick Links
            </h3>
            <ul className="space-y-3">
              {[
                { path: "/about", label: "About Us" },
                { path: "/courses", label: "Courses" },
                // { path: "/investment", label: "Investment Solutions" },
                // { path: "/testimonials", label: "Testimonials" },
                { path: "/faqs", label: "FAQs" },
                { path: "/", label: "Articles" },
                { path: "/contact", label: "Contact Us" }
              ].map((link, index) => (
                <motion.li 
                  key={index}
                  whileHover={{ x: 5 }}
                  transition={{ type: "spring", stiffness: 300 }}
                >
                  <Link 
                    to={link.path} 
                    onClick={handleScrollToTop}
                    className="text-gray-400 hover:text-white transition-all flex items-center group"
                  >
                    <span className="w-2 h-2 bg-gradient-to-r from-blue-400 to-purple-400 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                    {link.label}
                    <FaChevronRight className="ml-2 text-xs opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  </Link>
                </motion.li>
              ))}
            </ul>
          </motion.div>

          {/* Contact Info */}
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
            className="space-y-6"
          >
            <h3 className="text-lg font-bold border-b border-amber-400/30 pb-2 flex items-center">
              <FaEnvelope className="mr-2 text-sm" /> Contact Info
            </h3>
            <div className="space-y-4">
              <motion.div 
                whileHover={{ x: 3 }}
                className="flex items-start space-x-3"
              >
                <div className="bg-gradient-to-r from-blue-400 to-purple-400 p-1 rounded-full">
                  <FaEnvelope className="text-white text-xs" />
                </div>
                <a href="mailto:info@karikareduwealth.com" className="text-gray-400 hover:text-white transition-all">
                  info@karikareduwealth.com
                </a>
              </motion.div>
              <motion.div 
                whileHover={{ x: 3 }}
                className="flex items-center space-x-3"
              >
                <div className="bg-gradient-to-r from-blue-400 to-purple-400 p-1 rounded-full">
                  <FaPhoneAlt className="text-white text-xs" />
                </div>
                <a href="tel:+919876543210" className="text-gray-400 hover:text-white transition-all">
                  +91 98765 43210
                </a>
              </motion.div>
              <motion.div 
                whileHover={{ x: 3 }}
                className="flex items-start space-x-3"
              >
                <div className="bg-gradient-to-r from-blue-400 to-purple-400 p-1 rounded-full mt-1">
                  <FaCogs className="text-white text-xs" />
                </div>
                <p className="text-gray-400">Financial District, Mumbai, India</p>
              </motion.div>
            </div>
          </motion.div>

         {/* Office Location */}
<motion.div 
  initial={{ opacity: 0, y: 20 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.5, delay: 0.4 }}
  className="space-y-6"
>
  <h3 className="text-lg font-bold border-b border-amber-400/30 pb-2">
    Our Office
  </h3>
  
  
  <div className="w-full h-64  rounded-lg overflow-hidden shadow-lg">
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3023.1234567890!2d88.3638953151234!3d22.5726464851234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f89123456789abc%3A0xabcdef1234567890!2sYour+Office+Name!5e0!3m2!1sen!2sin!4v1690000000000!5m2!1sen!2sin"
      width="100%"
      height="100%"
      title='karikar'
      style={{ border: 0 }}
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    ></iframe>
  </div>

  {/* Get Directions Button */}
  <div className="mt-4 text-center">
    <a
      href="https://www.google.com/maps/dir/?api=1&destination=Your+Office+Address"
      target="_blank"
      rel="noopener noreferrer"
      className="inline-block bg-[#02ca02] text-white font-semibold px-6 py-2 rounded-lg hover:bg-[#028a02] transition"
    >
      Get Directions
    </a>
  </div>
</motion.div>


        </div>

        {/* CTA Section */}
        <div className='border-t border-gray-800 py-8'>
          <div className='text-center'>
            <h1 className='text-3xl md:text-4xl font-bold'>
              Have Financial Questions? <span className='text-[#02ca02]'>We Can Help</span> 
            </h1>
            <motion.button 
              className='bg-gradient-to-r from-[#02ca02] to-[#028a02] hover:from-[#028a02] hover:to-[#02ca02] text-white px-6 py-3 rounded-lg mt-4 transition-all'
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <Link to="/contact" onClick={handleScrollToTop}>
                Schedule Consultation
              </Link>
            </motion.button>
          </div>
        </div>

        {/* Footer Bottom */}
        <motion.div 
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  transition={{ duration: 0.8 }}
  className="border-t border-gray-800 pt-8"
>
  <div className="flex flex-col md:flex-row justify-between items-center gap-4">
      {/* Developer Credit */}
    <p className="text-gray-500 text-sm text-center md:text-right">
      Developed by{" "}
      <a href='https://merndigital.com' className="bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent font-medium">
        MERN Digital
      </a>{" "}
      &{" "}
      <a href='https://rayverse.in' className="text-red-500 font-medium">
        Rayverse
      </a>
    </p>
    {/* Client Credit */}
    <p className="text-gray-400 text-sm text-center md:text-left">
      © {new Date().getFullYear()} Karikar EduWealth Pvt. Ltd. All rights reserved.
    </p>

    {/* Links */}
    <div className="flex space-x-6">
      <Link 
        to="/privacy-policy" 
        onClick={handleScrollToTop} 
        className="text-gray-400 hover:text-white transition-colors duration-200 text-sm"
      >
        Privacy Policy
      </Link>
      <Link 
        to="/terms-and-conditions" 
        onClick={handleScrollToTop} 
        className="text-gray-400 hover:text-white transition-colors duration-200 text-sm"
      >
        Terms of Service
      </Link>
    </div>

  
  </div>
</motion.div>



        {/* Back to Top Button */}
        <motion.button 
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          onClick={handleScrollToTop}
          className="fixed bottom-8 right-8 bg-gradient-to-br from-[#02ca02] to-[#028a02] hover:from-[#028a02] hover:to-[#02ca02] text-white p-3 rounded-full shadow-xl transition-all transform hover:scale-110 z-50 flex items-center justify-center"
          aria-label="Back to top"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
        >
          <IoIosArrowUp className='text-xl text-[#fe0000]'/>
        </motion.button>
      </div>
    </footer>
  );
};

export default Footer;